import { render, staticRenderFns } from "./AuthorityGroup.vue?vue&type=template&id=79c519e3&"
import script from "./AuthorityGroup.vue?vue&type=script&lang=ts&"
export * from "./AuthorityGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports